import {
    INICIA_NOTAS_FALTAS,
    INICIO_NOTAS_FALTAS_SUCESSO,
    BUSCA_NOTAS_FALTAS,
    BUSCA_NOTAS_FALTAS_SUCESSO,
    LISTA_CURSOS_NOTAS_FALTAS,
    LISTA_CURSOS_NOTAS_FALTAS_SUCESSO,
    LISTA_SERIES_NOTAS_FALTAS,
    LISTA_SERIES_NOTAS_FALTAS_SUCESSO,
    LISTA_TURMAS_NOTAS_FALTAS,
    LISTA_TURMAS_NOTAS_FALTAS_SUCESSO,
    LISTA_ETAPAS_NOTAS_FALTAS,
    LISTA_ETAPAS_NOTAS_FALTAS_SUCESSO,
    LISTA_DISCIPLINAS_NOTAS_FALTAS_SUCESSO,
    LISTA_MATRICULAS_NOTAS_FALTAS_SUCESSO,
    LIMPAR_NOTAS_FALTAS,
    VOLTAR_PARA_FILTROS_NOTAS_FALTAS,
    ATUALIZA_NOTA_ALUNO,
    HIDE_MESSAGE,
    ON_HIDE_LOADER,
    ON_SHOW_LOADER,
    ON_SHOW_SUCCESS_MESSAGE,
    ON_SHOW_ERROR_MESSAGE,
    SHOW_MESSAGE,
    ALTERACAO_CAMPO,
    ALTERACAO_COMBO,
    SALVA_NOTA_FALTA_SUCESSO,
    SALVA_PARECER_DESCRITIVO_SUCESSO,
    SALVA_NOTA_CONSELHO_SUCESSO,
    SALVA_NOTA_RECUPERACAO_SUCESSO,
    SALVA_SITUACAO_MATRICULA,
    SALVA_SITUACAO_MATRICULA_SUCESSO
} from "constants/ActionTypes";

const INIT_STATE = {
    loader: false,
    alertMessage: '',
    showMessageSuccess: false,
    showMessageError: false,

    // Campos do formulário de filtro
    anoLetivo: '',
    escolaId: null,
    cursoId: null,
    serieId: null,
    turmaId: null,
    etapaId: null,
    disciplinaId: null,
    matriculaId: null,

    // Listas para os combos
    listaEscolas: [],
    listaCursos: [],
    listaSeries: [],
    listaTurmas: [],
    listaEtapas: [],
    listaDisciplinas: [],
    listaMatriculas: [],

    // Flags para saber se as listas já foram carregadas (para mostrar alertas de vazio)
    cursosCarregados: false,
    seriesCarregadas: false,
    turmasCarregadas: false,
    etapasCarregadas: false,

    // Resultado da busca
    resultadoBusca: null,
    buscando: false,

    // Estado da página de Lançamento
    exibirLancamento: false,
    tipoVisualizacao: null, // 'disciplina' ou 'matricula'
    dadosCabecalho: {},
    listaLancamentos: [],
    proximaEtapaId: null,
    etapaAnteriorId: null,
    filtrosAtuais: null, // Filtros usados na última busca
    regrasAvaliacao: null, // Regras de avaliação retornadas pelo backend
    salvandoSituacao: false
};

const normalizeEscolaItem = (e) => ({
    id: e.id || e.Id,
    title: e.nome || e.Nome || String(e.id || e.Id || '')
});

const normalizeCursoItem = (c) => {
    const id = c.id || c.Id || c.cursoId || c.CursoId;
    const nome = c.cursoNome || c.Nome || c.descricao || c.Descricao || c.titulo || c.Titulo || String(id || '');
    return { id, title: nome };
};

const normalizeSerieItem = (s) => {
    const id = s.id || s.Id || s.serieId || s.SerieId;
    const nome = s.nome || s.Nome || s.descricao || s.Descricao || s.titulo || s.Titulo || String(id || '');
    return { id, title: nome };
};

const normalizeTurmaItem = (t) => {
    const id = t.id || t.Id;
    const nome = t.nome || t.Nome || String(id || '');
    return { id, title: nome };
};

const normalizeEtapaItem = (e) => {
    const id = e.id || e.Id || e.etapaId || e.EtapaId;
    const nome = e.nome || e.Nome || e.descricao || e.Descricao || e.titulo || e.Titulo || String(id || '');
    return { id, title: nome };
};

const normalizeDisciplinaItem = (d) => {
    const id = d.id || d.Id || d.componenteCurricularId || d.disciplinaId;
    const nome = d.disciplinaNome || d.nome || d.Nome || (d.disciplina && d.disciplina.nome) || d.componenteCurricularNome || String(id || '');
    return { id, title: nome };
};

const normalizeMatriculaItem = (m) => {
    const id = m.id || m.Id || m.matriculaId || m.MatriculaId;
    const nomeAluno = m.AlunoNome || m.nomeAluno || m.NomeAluno || (m.aluno && (m.aluno.nome || m.aluno.Nome)) || '';
    const codigoMatricula = m.codigo || m.Codigo || m.codigoMatricula || '';
    const title = nomeAluno ? `${nomeAluno}${codigoMatricula ? ` (${codigoMatricula})` : ''}` : String(id || '');
    return { id, title };
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case INICIA_NOTAS_FALTAS: {
            return {
                ...state,
                loader: true,
                anoLetivo: '',
                escolaId: null,
                cursoId: null,
                serieId: null,
                turmaId: null,
                etapaId: null,
                disciplinaId: null,
                matriculaId: null,
                listaCursos: [],
                listaSeries: [],
                listaTurmas: [],
                listaEtapas: [],
                listaDisciplinas: [],
                listaMatriculas: [],
                cursosCarregados: false,
                seriesCarregadas: false,
                turmasCarregadas: false,
                etapasCarregadas: false,
                resultadoBusca: null,
                exibirLancamento: false,
                tipoVisualizacao: null,
                dadosCabecalho: {},
                listaLancamentos: [],
                buscando: false
            };
        }
        case INICIO_NOTAS_FALTAS_SUCESSO: {
            const escolasRaw = action.payload?.escolas || action.payload || [];
            const listaEscolas = Array.isArray(escolasRaw) ? escolasRaw.map(normalizeEscolaItem) : [];
            return { ...state, loader: false, listaEscolas };
        }
        case BUSCA_NOTAS_FALTAS: {
            // Determinar tipo de visualização baseado no filtro
            const tipoVisualizacao = action.payload?.matriculaId ? 'matricula' : 'disciplina';
            return { ...state, buscando: true, loader: true, tipoVisualizacao, filtrosAtuais: action.payload };
        }
        case BUSCA_NOTAS_FALTAS_SUCESSO: {
            const { dadosCabecalho, listaLancamentos, proximaEtapaId, etapaAnteriorId, regrasAvaliacao } = action.payload || {};

            // Se a lista de lançamentos vier vazia, não exibe a tela de lançamentos e mostra erro
            if (!listaLancamentos || listaLancamentos.length === 0) {
                return {
                    ...state,
                    buscando: false,
                    loader: false,
                    exibirLancamento: false,
                    resultadoBusca: null,
                    showMessageError: true,
                    alertMessage: "Não foram encontrados dados para o lançamento com os filtros selecionados."
                };
            }

            // Normalizar campo notaRecuperacao -> recuperacaoParalela
            let listaNormalizada = listaLancamentos || [];

            // Verificar se é estrutura aninhada (por matrícula) ou plana (por disciplina)
            const primeiroItem = listaNormalizada[0];
            const isNested = primeiroItem && primeiroItem.disciplinas !== undefined;

            if (isNested) {
                // Estrutura aninhada: [{ areaConhecimento, disciplinas: [...] }]
                listaNormalizada = listaNormalizada.map(area => ({
                    ...area,
                    disciplinas: (area.disciplinas || []).map(disc => ({
                        ...disc,
                        recuperacaoParalela: disc.notaRecuperacao !== undefined && disc.notaRecuperacao !== null && disc.notaRecuperacao !== ''
                            ? String(disc.notaRecuperacao)
                            : disc.recuperacaoParalela || ''
                    }))
                }));
            } else {
                // Estrutura plana: [{ matriculaId, nota, falta, ... }]
                listaNormalizada = listaNormalizada.map(item => ({
                    ...item,
                    recuperacaoParalela: item.notaRecuperacao !== undefined && item.notaRecuperacao !== null && item.notaRecuperacao !== ''
                        ? String(item.notaRecuperacao)
                        : item.recuperacaoParalela || ''
                }));
            }

            return {
                ...state,
                buscando: false,
                loader: false,
                resultadoBusca: action.payload,
                exibirLancamento: true,
                dadosCabecalho: dadosCabecalho || {},
                listaLancamentos: listaNormalizada,
                proximaEtapaId: proximaEtapaId || null,
                etapaAnteriorId: etapaAnteriorId || dadosCabecalho?.etapaAnteriorId || null,
                regrasAvaliacao: regrasAvaliacao || dadosCabecalho?.regrasAvaliacao || null
            };
        }
        // Reset carregados flags and clear lists when loading starts
        case LISTA_CURSOS_NOTAS_FALTAS: {
            return { ...state, listaCursos: [], cursosCarregados: false, seriesCarregadas: false, turmasCarregadas: false };
        }
        case LISTA_SERIES_NOTAS_FALTAS: {
            return { ...state, listaSeries: [], seriesCarregadas: false, turmasCarregadas: false };
        }
        case LISTA_TURMAS_NOTAS_FALTAS: {
            return { ...state, listaTurmas: [], turmasCarregadas: false };
        }
        case LISTA_ETAPAS_NOTAS_FALTAS: {
            return { ...state, listaEtapas: [], etapasCarregadas: false };
        }
        case LISTA_CURSOS_NOTAS_FALTAS_SUCESSO: {
            const cursosRaw = action.payload?.cursos || action.payload || [];
            const listaCursos = Array.isArray(cursosRaw) ? cursosRaw.map(normalizeCursoItem) : [];
            return { ...state, listaCursos, cursosCarregados: true };
        }
        case LISTA_SERIES_NOTAS_FALTAS_SUCESSO: {
            const seriesRaw = action.payload?.series || action.payload || [];
            const listaSeries = Array.isArray(seriesRaw) ? seriesRaw.map(normalizeSerieItem) : [];
            return { ...state, listaSeries, seriesCarregadas: true };
        }
        case LISTA_TURMAS_NOTAS_FALTAS_SUCESSO: {
            const turmasRaw = action.payload?.turmas || action.payload || [];
            const listaTurmas = Array.isArray(turmasRaw) ? turmasRaw.map(normalizeTurmaItem) : [];
            return { ...state, listaTurmas, turmasCarregadas: true };
        }
        case LISTA_ETAPAS_NOTAS_FALTAS_SUCESSO: {
            const etapasRaw = action.payload?.etapas || action.payload || [];
            const listaEtapas = Array.isArray(etapasRaw) ? etapasRaw.map(normalizeEtapaItem) : [];
            return { ...state, listaEtapas, etapasCarregadas: true };
        }
        case LISTA_DISCIPLINAS_NOTAS_FALTAS_SUCESSO: {
            const disciplinasRaw = action.payload?.disciplinas || action.payload || [];
            const listaDisciplinas = Array.isArray(disciplinasRaw) ? disciplinasRaw.map(normalizeDisciplinaItem) : [];
            return { ...state, listaDisciplinas };
        }
        case LISTA_MATRICULAS_NOTAS_FALTAS_SUCESSO: {
            const matriculasRaw = action.payload?.matriculas || action.payload || [];
            const listaMatriculas = Array.isArray(matriculasRaw) ? matriculasRaw.map(normalizeMatriculaItem) : [];
            return { ...state, listaMatriculas };
        }
        case LIMPAR_NOTAS_FALTAS: {
            return {
                ...state,
                anoLetivo: '',
                escolaId: null,
                cursoId: null,
                serieId: null,
                turmaId: null,
                etapaId: null,
                disciplinaId: null,
                matriculaId: null,
                listaCursos: [],
                listaSeries: [],
                listaTurmas: [],
                listaEtapas: [],
                listaDisciplinas: [],
                listaMatriculas: [],
                cursosCarregados: false,
                seriesCarregadas: false,
                turmasCarregadas: false,
                etapasCarregadas: false,
                resultadoBusca: null
            };
        }
        case VOLTAR_PARA_FILTROS_NOTAS_FALTAS: {
            return {
                ...state,
                exibirLancamento: false,
                tipoVisualizacao: null,
                dadosCabecalho: {},
                listaLancamentos: [],
                resultadoBusca: null
            };
        }
        case ATUALIZA_NOTA_ALUNO: {
            const { matriculaId, campo, valor } = action.payload;

            // Verificar se a estrutura é aninhada (por matrícula: áreas -> disciplinas)
            // ou plana (por disciplina: lista de alunos)
            const primeiroItem = state.listaLancamentos[0];
            const isNested = primeiroItem && primeiroItem.disciplinas !== undefined;

            if (isNested) {
                // Estrutura aninhada: [{ areaConhecimento, disciplinas: [...] }]
                const listaAtualizada = state.listaLancamentos.map(area => ({
                    ...area,
                    disciplinas: (area.disciplinas || []).map(disc => {
                        // Comparar apenas com componenteEscolaId para evitar duplicatas
                        if (disc.componenteEscolaId === matriculaId) {
                            return { ...disc, [campo]: valor };
                        }
                        return disc;
                    })
                }));
                return { ...state, listaLancamentos: listaAtualizada };
            } else {
                // Estrutura plana: [{ matriculaId, nota, falta, ... }]
                const listaAtualizada = state.listaLancamentos.map(item => {
                    if (item.matriculaId === matriculaId) {
                        return { ...item, [campo]: valor };
                    }
                    return item;
                });
                return { ...state, listaLancamentos: listaAtualizada };
            }
        }
        case SALVA_PARECER_DESCRITIVO_SUCESSO: {
            const { matriculaId, componenteEscolaId, parecer, tipoParecer } = action.payload;

            // Verificar se a estrutura é aninhada ou plana (similar ao SALVA_NOTA_FALTA_SUCESSO)
            const primeiroItem = state.listaLancamentos[0];
            const isNested = primeiroItem && primeiroItem.disciplinas !== undefined;

            if (isNested) {
                // Estrutura aninhada: [{ areaConhecimento, disciplinas: [...] }]
                // Lançamento Por Matrícula
                const listaAtualizada = state.listaLancamentos.map(area => ({
                    ...area,
                    disciplinas: (area.disciplinas || []).map(disc => {
                        // Regra para Tipos 2 e 4: Parecer Geral (por Etapa ou Ano)
                        // Atualiza todas as disciplinas da mesma matrícula
                        // 2: Um parecer por etapa, geral para todos os componentes
                        // 4: Um parecer por ano letivo, geral
                        const isGeral = tipoParecer == 2 || tipoParecer == 4;

                        // Se for geral, atualiza se 'disc' pertencer à mesma matrícula (embora aqui 'area.disciplinas' sejam do aluno da tela)
                        // No contexto 'Por Matrícula', todos os itens são do mesmo aluno? 
                        // Verificando: 'lancamentoPorMatricula.js' renderiza disciplinas de UM aluno (dadosCabecalho.matriculaId).
                        // ENTÃO: 'area.disciplinas' são todas do aluno.
                        // LOGO: Se for Geral (3 ou 5), atualizamos TODOS os itens.
                        // Se NÃO for geral, atualizamos apenas o item que bate com o componenteEscolaId.

                        if (isGeral) {
                            return { ...disc, parecerDescritivo: parecer };
                        } else {
                            if (disc.componenteEscolaId === componenteEscolaId) {
                                return { ...disc, parecerDescritivo: parecer };
                            }
                        }
                        return disc;
                    })
                }));
                return { ...state, listaLancamentos: listaAtualizada };
            } else {
                // Estrutura plana: [{ matriculaId, nota, falta, ... }]
                // Lançamento Por Disciplina (Lista de Alunos)
                // Aqui cada linha é UM aluno diferente.
                // Se for Geral (3/5) ou Específico (2/4), afeta apenas O ALUNO específico (matriculaId).
                // Como cada linha é um aluno/disciplina (mas na tela "Por Disciplina", é uma disciplina fixa para vários alunos).
                // Então só precisamos atualizar a linha do aluno correspondente.

                const listaAtualizada = state.listaLancamentos.map(item => {
                    if (item.matriculaId === matriculaId) {
                        return { ...item, parecerDescritivo: parecer };
                    }
                    return item;
                });
                return { ...state, listaLancamentos: listaAtualizada };
            }
        }
        case SALVA_NOTA_FALTA_SUCESSO: {
            const { matriculaId, componenteEscolaId, notaNumerica, faltas, situacao, notaNecessariaConselho, notaNecessariaAprovacao, notaNecessariaAprovacaoConceitual, notaRecuperacao, conselhoLiberado } = action.payload;

            // Composição: o backend ecoa o modo persistido e as sub-notas (mesmo em modo livre)
            const modoComposicao = action.payload.modoComposicao !== undefined ? action.payload.modoComposicao : action.payload.ModoComposicao;
            const notasAuxiliares = action.payload.notasAuxiliares !== undefined ? action.payload.notasAuxiliares : action.payload.NotasAuxiliares;
            const notasAdicionais = action.payload.notasAdicionais !== undefined ? action.payload.notasAdicionais : action.payload.NotasAdicionais;

            // Verificar se a estrutura é aninhada ou plana, similar ao ATUALIZA_NOTA_ALUNO
            const primeiroItem = state.listaLancamentos[0];
            const isNested = primeiroItem && primeiroItem.disciplinas !== undefined;

            if (isNested) {
                // Estrutura aninhada: [{ areaConhecimento, disciplinas: [...] }]

                // Verificar se a regra de presença é unificada (tipoPresenca === 1)
                // Se a regra de avaliação não estiver no estado, tenta pegar do payload se vier (raro), ou assume que está no state.regrasAvaliacao
                const tipoPresenca = state.regrasAvaliacao?.tipoPresenca;
                const isPresencaUnificada = tipoPresenca === 1;

                const listaAtualizada = state.listaLancamentos.map(area => ({
                    ...area,
                    disciplinas: (area.disciplinas || []).map(disc => {
                        // Se atualizamos PRESENÇA (faltas) e É UNIFICADA, atualiza TODOS OS COMPONENTES da matrícula (que são todos aqui)
                        // Se não for unificada, ou se estivermos atualizando NOTA, só atualiza o componente específico.

                        const atualizandoFaltas = faltas !== undefined && faltas !== null;
                        const deveAtualizarEsteComponente = disc.componenteEscolaId === componenteEscolaId;

                        // Lógica:
                        // 1. Se for o componente alvo, atualiza tudo que mudou.
                        // 2. Se NÃO for o componente alvo, mas estamos atualizando FALTAS e é PRESENÇA UNIFICADA, atualiza a falta deste também.

                        if (deveAtualizarEsteComponente) {
                            return {
                                ...disc,
                                nota: notaNumerica !== undefined && notaNumerica !== null ? String(notaNumerica) : disc.nota,
                                falta: faltas !== undefined && faltas !== null ? String(faltas) : disc.falta,
                                situacao: situacao !== undefined ? situacao : disc.situacao,
                                notaNecessariaConselho: notaNecessariaConselho !== undefined ? String(notaNecessariaConselho) : disc.notaNecessariaConselho,
                                notaNecessariaAprovacao: notaNecessariaAprovacao !== undefined ? String(notaNecessariaAprovacao) : disc.notaNecessariaAprovacao,
                                notaNecessariaAprovacaoConceitual: notaNecessariaAprovacaoConceitual !== undefined ? notaNecessariaAprovacaoConceitual : disc.notaNecessariaAprovacaoConceitual,
                                recuperacaoParalela: notaRecuperacao !== undefined && notaRecuperacao !== null ? String(notaRecuperacao) : disc.recuperacaoParalela,
                                conselhoLiberado: conselhoLiberado !== undefined ? conselhoLiberado : disc.conselhoLiberado,
                                modoComposicao: modoComposicao !== undefined ? modoComposicao : disc.modoComposicao,
                                notasAuxiliares: notasAuxiliares !== undefined ? notasAuxiliares : disc.notasAuxiliares,
                                notasAdicionais: notasAdicionais !== undefined ? notasAdicionais : disc.notasAdicionais
                            };
                        } else if (atualizandoFaltas && isPresencaUnificada) {
                            return {
                                ...disc,
                                falta: String(faltas)
                                // Nota e outros status específicos da disciplina NÃO mudam aqui, pois pertencem a outra disciplina
                            };
                        }

                        return disc;
                    })
                }));
                return { ...state, listaLancamentos: listaAtualizada };
            } else {
                // Estrutura plana: [{ matriculaId, nota, falta, ... }]

                const tipoPresenca = state.regrasAvaliacao?.tipoPresenca;
                const isPresencaUnificada = tipoPresenca === 1;

                const listaAtualizada = state.listaLancamentos.map(item => {
                    const atualizandoFaltas = faltas !== undefined && faltas !== null;

                    // Verifica se o item pertence à matrícula que estamos atualizando
                    if (item.matriculaId === matriculaId) {
                        const ehComponenteAlvo = !componenteEscolaId || item.componenteEscolaId === componenteEscolaId; // Se não tiver componenteEscolaId, assume único ou ignora. Mas deveria ter.

                        if (ehComponenteAlvo) {
                            return {
                                ...item,
                                nota: notaNumerica !== undefined && notaNumerica !== null ? String(notaNumerica) : item.nota,
                                falta: faltas !== undefined && faltas !== null ? String(faltas) : item.falta,
                                situacao: situacao !== undefined ? situacao : item.situacao,
                                notaNecessariaConselho: notaNecessariaConselho !== undefined ? String(notaNecessariaConselho) : item.notaNecessariaConselho,
                                notaNecessariaAprovacao: notaNecessariaAprovacao !== undefined ? String(notaNecessariaAprovacao) : item.notaNecessariaAprovacao,
                                notaNecessariaAprovacaoConceitual: notaNecessariaAprovacaoConceitual !== undefined ? notaNecessariaAprovacaoConceitual : item.notaNecessariaAprovacaoConceitual,
                                recuperacaoParalela: notaRecuperacao !== undefined && notaRecuperacao !== null ? String(notaRecuperacao) : item.recuperacaoParalela,
                                conselhoLiberado: conselhoLiberado !== undefined ? conselhoLiberado : item.conselhoLiberado,
                                modoComposicao: modoComposicao !== undefined ? modoComposicao : item.modoComposicao,
                                notasAuxiliares: notasAuxiliares !== undefined ? notasAuxiliares : item.notasAuxiliares,
                                notasAdicionais: notasAdicionais !== undefined ? notasAdicionais : item.notasAdicionais
                            };
                        } else if (atualizandoFaltas && isPresencaUnificada) {
                            // Atualiza apenas a falta dos outros componentes desta matrícula
                            return {
                                ...item,
                                falta: String(faltas)
                            };
                        }
                    }
                    return item;
                });
                return { ...state, listaLancamentos: listaAtualizada };
            }
        }
        case SALVA_NOTA_CONSELHO_SUCESSO: {
            const { matriculaId, componenteEscolaId, notaAtribuida, notaConceitualAtribuida, situacao } = action.payload;
            const notaConselho = notaConceitualAtribuida || notaAtribuida;

            // Verificar se a estrutura é aninhada ou plana
            const primeiroItem = state.listaLancamentos[0];
            const isNested = primeiroItem && primeiroItem.disciplinas !== undefined;

            if (isNested) {
                // Estrutura aninhada: [{ areaConhecimento, disciplinas: [...] }]
                const listaAtualizada = state.listaLancamentos.map(area => ({
                    ...area,
                    disciplinas: (area.disciplinas || []).map(disc => {
                        if (disc.componenteEscolaId === componenteEscolaId) {
                            return {
                                ...disc,
                                notaConselho: notaConselho !== undefined && notaConselho !== null ? String(notaConselho) : disc.notaConselho,
                                situacao: situacao !== undefined ? situacao : disc.situacao
                            };
                        }
                        return disc;
                    })
                }));
                return { ...state, listaLancamentos: listaAtualizada };
            } else {
                // Estrutura plana: [{ matriculaId, nota, falta, ... }]
                const listaAtualizada = state.listaLancamentos.map(item => {
                    if (item.matriculaId === matriculaId) {
                        return {
                            ...item,
                            notaConselho: notaConselho !== undefined && notaConselho !== null ? String(notaConselho) : item.notaConselho,
                            situacao: situacao !== undefined ? situacao : item.situacao
                        };
                    }
                    return item;
                });
                return { ...state, listaLancamentos: listaAtualizada };
            }
        }
        case HIDE_MESSAGE: {
            return { ...state, alertMessage: '', showMessageSuccess: false, showMessageError: false, loader: false };
        }
        case ON_HIDE_LOADER: {
            return { ...state, loader: false };
        }
        case ON_SHOW_LOADER: {
            return { ...state, loader: true };
        }
        case ON_SHOW_ERROR_MESSAGE: {
            return { ...state, loader: false, alertMessage: action.payload, showMessageError: true };
        }
        case ON_SHOW_SUCCESS_MESSAGE: {
            return { ...state, loader: false, alertMessage: action.payload, showMessageSuccess: true };
        }
        case SHOW_MESSAGE: {
            return { ...state, alertMessage: action.payload, showMessageError: true, loader: false };
        }
        case ALTERACAO_CAMPO: {
            return { ...state, [action.payload.target.name]: action.payload.target.value };
        }
        case ALTERACAO_COMBO: {
            const valorBruto = action.payload.valor;
            const valorNormalizado = (valorBruto && typeof valorBruto === 'object')
                ? (valorBruto.id !== undefined ? valorBruto.id : (valorBruto.value !== undefined ? valorBruto.value : valorBruto))
                : valorBruto;
            const chave = action.payload.nomeCombo;
            return { ...state, [chave]: valorNormalizado };
        }
        case SALVA_NOTA_RECUPERACAO_SUCESSO: {
            const { matriculaId, componenteEscolaId, notaNumerica, notaConceitual, situacao, conselhoLiberado, notaNecessariaConselho, notaNecessariaAprovacao, notaNecessariaAprovacaoConceitual } = action.payload;
            // A nota de recuperação a ser mostrada.
            // Se for conceitual, usa notaConceitual, senão notaNumerica.
            // O payload de retorno tem 'notaNumerica' e 'notaConceitual'.
            // Vamos guardar no campo 'recuperacaoParalela' (valor string para o input).

            let novoValor = null;
            if (notaConceitual !== null && notaConceitual !== undefined) {
                novoValor = String(notaConceitual);
            } else if (notaNumerica !== null && notaNumerica !== undefined) {
                novoValor = String(notaNumerica);
            }

            // Verificar se a estrutura é aninhada ou plana
            const primeiroItem = state.listaLancamentos[0];
            const isNested = primeiroItem && primeiroItem.disciplinas !== undefined;

            if (isNested) {
                // Estrutura aninhada: [{ areaConhecimento, disciplinas: [...] }]
                const listaAtualizada = state.listaLancamentos.map(area => ({
                    ...area,
                    disciplinas: (area.disciplinas || []).map(disc => {
                        if (disc.componenteEscolaId === componenteEscolaId) {
                            return {
                                ...disc,
                                recuperacaoParalela: novoValor !== null ? novoValor : disc.recuperacaoParalela,
                                situacao: situacao !== undefined ? situacao : disc.situacao,
                                conselhoLiberado: conselhoLiberado !== undefined ? conselhoLiberado : disc.conselhoLiberado,
                                notaNecessariaConselho: notaNecessariaConselho !== undefined ? String(notaNecessariaConselho) : disc.notaNecessariaConselho,
                                notaNecessariaAprovacao: notaNecessariaAprovacao !== undefined ? String(notaNecessariaAprovacao) : disc.notaNecessariaAprovacao,
                                notaNecessariaAprovacaoConceitual: notaNecessariaAprovacaoConceitual !== undefined ? notaNecessariaAprovacaoConceitual : disc.notaNecessariaAprovacaoConceitual
                            };
                        }
                        return disc;
                    })
                }));
                return { ...state, listaLancamentos: listaAtualizada };
            } else {
                // Estrutura plana: [{ matriculaId, nota, falta, ... }]
                const listaAtualizada = state.listaLancamentos.map(item => {
                    if (item.matriculaId === matriculaId && item.componenteEscolaId === componenteEscolaId) {
                        return {
                            ...item,
                            recuperacaoParalela: novoValor !== null ? novoValor : item.recuperacaoParalela,
                            situacao: situacao !== undefined ? situacao : item.situacao,
                            conselhoLiberado: conselhoLiberado !== undefined ? conselhoLiberado : item.conselhoLiberado,
                            notaNecessariaConselho: notaNecessariaConselho !== undefined ? String(notaNecessariaConselho) : item.notaNecessariaConselho,
                            notaNecessariaAprovacao: notaNecessariaAprovacao !== undefined ? String(notaNecessariaAprovacao) : item.notaNecessariaAprovacao,
                            notaNecessariaAprovacaoConceitual: notaNecessariaAprovacaoConceitual !== undefined ? notaNecessariaAprovacaoConceitual : item.notaNecessariaAprovacaoConceitual
                        };
                    } else if (item.matriculaId === matriculaId && !componenteEscolaId) {
                        // Fallback se componenteEscolaId não vier (difícil acontecer dado o merge)
                        return {
                            ...item,
                            recuperacaoParalela: novoValor !== null ? novoValor : item.recuperacaoParalela,
                            situacao: situacao !== undefined ? situacao : item.situacao,
                            conselhoLiberado: conselhoLiberado !== undefined ? conselhoLiberado : item.conselhoLiberado,
                            notaNecessariaConselho: notaNecessariaConselho !== undefined ? String(notaNecessariaConselho) : item.notaNecessariaConselho,
                            notaNecessariaAprovacao: notaNecessariaAprovacao !== undefined ? String(notaNecessariaAprovacao) : item.notaNecessariaAprovacao,
                            notaNecessariaAprovacaoConceitual: notaNecessariaAprovacaoConceitual !== undefined ? notaNecessariaAprovacaoConceitual : item.notaNecessariaAprovacaoConceitual
                        };
                    }
                    return item;
                });
                return { ...state, listaLancamentos: listaAtualizada };
            }
        }
        case SALVA_SITUACAO_MATRICULA: {
            return {
                ...state,
                salvandoSituacao: true
            };
        }
        case SALVA_SITUACAO_MATRICULA_SUCESSO: {
            const { situacao } = action.payload;
            // Atualizar no cabeçalho
            return {
                ...state,
                salvandoSituacao: false,
                dadosCabecalho: {
                    ...state.dadosCabecalho,
                    situacao: situacao
                }
            };
        }
        default:
            return state;
    }
}
